export const themeColor = "#90E0EF";
export const darkThemeColor = "#00B4D8";
export const hoverEffect = `#48819A`;
export const cardShadow = `rgba(0,0,0,0.1) 0px 20px 25px -5px,
    rgba(0,0,0,0.04) 0px 10px 10px -5px`;